<template>
  <v-container>
    <template v-if="!loading">
      <v-row>
        <v-col cols="12" lg="10" offset-lg="1" class="mt-12">
          <h2 class="subtitle">
            {{ $t("message.common.marketingConsents") }}
          </h2>
          <v-list>
            <v-list-item class="pa-0">
              <v-list-item-content>
                <div class="d-flex align-center">
                  <p class="consent__description">
                    {{ $t("message.session.agreement.newsletterAndMarketing") }}
                  </p>
                  <v-switch
                    inset
                    color="primary"
                    v-model="isMarketingConsent"
                    class="mt-0 ml-8"
                    hide-details
                    :loading="consentLoading"
                    @change="setUserMarketingConsent"
                  ></v-switch>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <SectionLoader :status="loading" :opacity="1" />
      </v-row>
    </template>
  </v-container>
</template>

<script>
import SectionLoader from "@/components/Loader/SectionLoader.vue";

import usersService from "@/services/users";
import serviceHandler from "@/helpers/handlers/service";

export default {
  name: "UserSettingsConsentsAndRegulations",
  components: {
    SectionLoader
  },
  data() {
    return {
      loading: false,
      consentLoading: false,
      isMarketingConsent: false
    };
  },

  async created() {
    this.loading = true;
    await this.getUserMarketingConsent();
    this.loading = false;
  },

  methods: {
    async getUserMarketingConsent() {
      const { is_marketing_consent } = await serviceHandler(
        usersService.getUserDetails()
      );

      this.isMarketingConsent = is_marketing_consent;
    },

    async setUserMarketingConsent() {
      this.consentLoading = true;
      await serviceHandler(
        usersService.patchUserDetails({
          is_marketing_consent: this.isMarketingConsent
        })
      );
      this.consentLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.consent__description {
  font-weight: $font-weight-light;
  line-height: 20px;
  margin-bottom: 0;
}

.subtitle {
  @include font-size(16px);
}
</style>
